import { render, staticRenderFns } from "./TheMainLayout.vue?vue&type=template&id=7a3ea978"
import script from "./TheMainLayout.vue?vue&type=script&lang=js"
export * from "./TheMainLayout.vue?vue&type=script&lang=js"
import style0 from "./TheMainLayout.vue?vue&type=style&index=0&id=7a3ea978&prod&scope=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports